import { render, staticRenderFns } from "./ViewNotFound.vue?vue&type=template&id=afd1cf64&scoped=true&"
import script from "./ViewNotFound.vue?vue&type=script&lang=ts&"
export * from "./ViewNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./ViewNotFound.vue?vue&type=style&index=0&id=afd1cf64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd1cf64",
  null
  
)

export default component.exports